export const fakePromiseDelay = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
